import Skeleton from 'react-loading-skeleton';
import {TrainingCard} from '../../../Components';
import './SmartTrainingCard.css';

const SmartTrainingCard = ({ training, loading, error, delay = 0 }) => {
    if (loading || error || !training) {
        return (
            <li className="theTrain loadingTrain" data-aos="fade-up" data-aos-delay={`${delay}00`}>
                <h2 className="train-title">
                    <Skeleton 
                    height={35}
                    style={{border:'1px solid var(--bg-footer)', width:'65%'}}
                    baseColor="var(--bg-footer)"
                    highlightColor="var(--bg-body)"
                        />
                </h2>
                <ul className="train-points">
                    {[...Array(3)].map((_, i) => (
                        <li className="train-point" key={i}>
                            <Skeleton 
                            height={20}
                            style={{border:'1px solid var(--bg-footer)', width:'85%'}}
                            baseColor="var(--bg-footer)"
                            highlightColor="var(--bg-body)"
                            />
                        </li>
                    ))}
                </ul>
            </li>
        );
    }

    return <TrainingCard training={training} delay={delay} />;
};
export default SmartTrainingCard;